import React from 'react'

export const SoldSymbol = ({
  className,
  size,
}: {
  className?: string
  size: number
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 11 11'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M5.74414 5.11322L9.29096 1.56641'
        stroke='currentColor'
        stroke-width='0.854527'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M9.63673 3.29884V1.22266H7.56055'
        stroke='currentColor'
        stroke-width='0.854527'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M4.87917 1.22266H4.0141C1.8514 1.22266 0.986328 2.08773 0.986328 4.25042V6.84565C0.986328 9.00835 1.8514 9.87342 4.0141 9.87342H6.60933C8.77202 9.87342 9.6371 9.00835 9.6371 6.84565V5.98058'
        stroke='currentColor'
        stroke-width='0.854527'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  )
}
